var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-table-cell',{staticClass:"toggle",class:{'is-active': _vm.value},attrs:{"align":"center"}},[(_vm.value)?_c('app-icon',{staticClass:"toggle-icon",attrs:{"icon":"tick"}}):_vm._e(),(!_vm.value)?_c('app-icon',{staticClass:"toggle-icon",attrs:{"icon":"cross"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }